export const boxStyleCustom = {
    backgroundColor: 'white',
    padding: 2,
    borderRadius: 2, // 2 = 16px (default theme spacing unit * 0.5)
    '& .MuiCardContent-root': {
        padding: 2,
    },
    '& .MuiCardActions-root': {
        padding: 1,
    },
    '& .MuiTypography-h6': {
        fontSize: '1.25rem', // 20px
        fontWeight: 'bold',
    },
    '& .MuiTypography-body1': {
        fontSize: '1rem', // 16px
    },
};

export const boxStyleHighlighted = {
    backgroundColor: 'rgb(214, 252, 255)',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: '24px',
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    alignItems: 'center',
    marginBottom: '60px'
}

